var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function Svg404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "48.000000pt",
    height: "48.000000pt",
    viewBox: "0 0 48.000000 48.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,48.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44 429 c-17 -19 -19 -38 -19 -190 0 -227 -13 -214 215 -214 228 0 215 -13 215 214 0 226 16 211 -215 211 -167 0 -178 -1 -196 -21z m374 -46 l3 -33 -180 0 -181 0 0 28 c0 16 3 32 7 36 4 3 84 5 177 4 l171 -3 3 -32z m2 -188 c0 -125 0 -125 -26 -135 -33 -13 -275 -13 -308 0 -26 10 -26 10 -26 135 l0 125 180 0 180 0 0 -125z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 390 c0 -5 7 -10 15 -10 8 0 15 5 15 10 0 6 -7 10 -15 10 -8 0 -15 -4 -15 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300 390 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350 390 c0 -5 7 -10 15 -10 8 0 15 5 15 10 0 6 -7 10 -15 10 -8 0 -15 -4 -15 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95 230 c-7 -23 10 -60 30 -60 7 0 17 -9 20 -20 13 -41 35 -14 35 43 0 18 -5 39 -10 47 -9 13 -11 13 -20 0 -5 -8 -10 -22 -11 -30 0 -8 -5 -3 -11 13 -11 32 -24 35 -33 7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211 236 c-17 -21 -10 -87 12 -100 27 -17 51 5 55 48 4 41 -11 66 -38 66 -10 0 -23 -6 -29 -14z m39 -46 c0 -16 -4 -30 -10 -30 -5 0 -10 14 -10 30 0 17 5 30 10 30 6 0 10 -13 10 -30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305 230 c-7 -23 10 -60 30 -60 7 0 17 -9 20 -20 13 -41 35 -14 35 43 0 18 -5 39 -10 47 -9 13 -11 13 -20 0 -5 -8 -10 -22 -11 -30 0 -8 -5 -3 -11 13 -11 32 -24 35 -33 7z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.e60f3aa7c265db3ac13437ca938dedc4.svg";
export { ForwardRef as ReactComponent };